import { message, modal } from "../components/app/globalApp";

import config from "../config";
import { intl } from "../containers/app";

/**
 * zavolá message.success z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const success = (userMessage: string, duration?: number) =>
  message.success(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zavolá message.error z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const error = (userMessage: string, duration?: number) =>
  message.error(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zavolá message.warn z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const warn = (userMessage: string, duration?: number) =>
  message.warning(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zobrazí vyskakovací okno se zprávou
 * @param userMessage zpráva pro uživatele
 */
export const warningModal = (userMessage: string) =>
modal.warning({
    title: intl.formatMessage({
      id: "messages.warning",
      defaultMessage: "Upozornění",
    }),
    content:
      userMessage ||
      intl.formatMessage({
        id: "messages.error",
        defaultMessage: "Při odesílání dat nastala chyba!",
      }),
  });
